module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Copyright © Geirr H Haarr 2010")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("First published in Great Britain in 2010 by"), _c('br'), _vm._v("\nSeaforth Publishing,"), _c('br'), _vm._v("\nPen & Sword Books Ltd,"), _c('br'), _vm._v("\n47 Church Street,"), _c('br'), _vm._v("\nBarnsley S70 2AS")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.seaforthpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.seaforthpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('i', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v("\nA catalogue record for this book is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978 1 84832 057 4"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 78346 905 5"), _c('br'), _vm._v("\nPRC ISBN: 978 1 78346 672 6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or"), _c('br'), _vm._v("\nby any means, electronic or mechanical, including photocopying, recording, or any information"), _c('br'), _vm._v("\nstorage and retrieval system, without prior permission in writing of both the copyright owner and"), _c('br'), _vm._v("\nthe above publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("The right of Geirr H Haarr to be identified as the author of this work has been asserted by him in"), _c('br'), _vm._v("\naccordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Typeset and designed by JCS Publishing Services Ltd, "), _c('a', {
    attrs: {
      "href": "http://www.jcs-publishing.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.jcs-publishing.co.uk")]), _c('br'), _vm._v("\nPrinted and bound in Great Britain by the MPG Books Group")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 63
// module chunks = 0